<template>
	<span class="d-flex align-center black--text color-name">
		<template v-if="article.color">
			<v-avatar
				:color="article.color.hex"
				:size="$vuetify.breakpoint.smAndDown ? 20 : 17"
				class="mr-1"
			></v-avatar>
			{{ article.color.name }}
		</template>

		<template v-if="article.type_of_finish">
			{{ article.type_of_finish.name }}
		</template>
	</span>
</template>

<script>
export default {
	name: "Color",

	props: ["article"],

	data() {
		return {};
	},
};
</script>

<style lang="css" scoped>
.color-name {
	font-size: 0.8rem;
}
/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 1264px) {
}
</style>
